import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PsaContent from '../components/PsaContent';
import PsaShareButtons from '../components/PsaShareButtons';
import SiteSections from '../components/SiteSections';

export default function Psa() {
  return (
    <div className="min-h-screen bg-neutral-50" data-testid="psa-page">
      <div className="max-w-4xl mx-auto px-4 py-6 sm:py-10">
        <Link
          to="/"
          data-testid="psa-back-home"
          className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-neutral-900 mb-4"
        >
          <ArrowLeft size={14}/> Back to home
        </Link>
        <div className="rounded-3xl overflow-hidden bg-white border border-neutral-200 shadow-lg">
          <PsaContent autoPlay={true} />
        </div>
        <PsaShareButtons />
      </div>
      <SiteSections pageKey="psa" />
    </div>
  );
}
